import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FaTrashAlt, FaCheckCircle, FaEdit } from 'react-icons/fa';
import EditModal from './EditModal';
import Button from '../common/Button'; // Importando o componente genérico

function RecebivelItem({ recebivel, onStatusChange, onDelete, onSave }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEdit = () => {
    setIsModalOpen(true);
  };

  return (
    <div
      className={`p-3 rounded-lg shadow-md transition-transform transform hover:scale-105 flex flex-col justify-between 
      ${
        recebivel.status === 'Recebido'
          ? 'bg-green-50 border-green-400'
          : 'bg-red-50 border-red-400'
      } min-w-0`}
    >
      <div className="flex-grow">
        <h3 className="text-sm font-bold text-gray-800 mb-1 truncate">
          {recebivel.descricao}
        </h3>
        <p className="text-xs text-gray-700 mb-1 truncate">
          <span className="font-semibold">Valor:</span> R${' '}
          {recebivel.valor.toFixed(2)}
        </p>
        <p className="text-xs text-gray-700 mb-1 truncate">
          <span className="font-semibold">Data:</span>{' '}
          {recebivel.dataRecebimento}
        </p>
        <p className="text-xs text-gray-700 truncate">
          <span className="font-semibold">Status:</span> {recebivel.status}
        </p>
      </div>
      <div className="flex space-x-1 mt-2">
        {recebivel.status === 'Pendente' && (
          // Substituindo o botão de "Recebido" pelo componente genérico
          <Button
            type="confirmar"
            label={
              <>
                <FaCheckCircle className="inline-block mr-1" /> Recebido
              </>
            }
            onClick={() => onStatusChange(recebivel.id, 'Recebido')}
            className="w-1/3 py-1 text-xs"
          />
        )}
        {/* Substituindo o botão de "Editar" pelo componente genérico */}
        <Button
          type="editar"
          label={
            <>
              <FaEdit className="inline-block mr-1" /> Editar
            </>
          }
          onClick={handleEdit}
          className="w-1/3 py-1 text-xs"
        />
        {/* Substituindo o botão de "Deletar" pelo componente genérico */}
        <Button
          type="remover"
          label={
            <>
              <FaTrashAlt className="inline-block mr-1" /> Deletar
            </>
          }
          onClick={() => onDelete(recebivel.id)}
          className="w-1/3 py-1 text-xs"
        />
      </div>
      <EditModal
        recebivel={recebivel}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={onSave}
      />
    </div>
  );
}

// Adicionando propTypes para garantir a validação das props
RecebivelItem.propTypes = {
  recebivel: PropTypes.shape({
    id: PropTypes.string.isRequired,
    descricao: PropTypes.string.isRequired,
    valor: PropTypes.number.isRequired,
    dataRecebimento: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default RecebivelItem;
